// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-theme-quartz {
  --ag-background-color: 'transparent';
  /* --ag-background-color: white; */
  --ag-header-column-separator-display: 'none';
  --ag-checkbox-background-color: #E0E0E0;
  --ag-checkbox-checked-color: var(--primary-color);
  --ag-checkbox-unchecked-color: var(--background-color);
  --ag-checkbox-indeterminate-color: white;


  --ag-header-column-separator-width: 0px !important;

}

.ag-theme-quartz .ag-popup {
  background-color: white !important;
}

.ag-root-wrapper {
  border: none;
  border-radius: 8px 8px 0px 0px;
}


.ag-ltr .ag-cell {
  /* border-right: 1px solid #ccc !important; */
  color: var(--text-color) !important;
  text-align: left !important;
  font-size: 12px !important;
}

.ag-header-cell {
  /* background-color: var(--primary-color) !important;*/
  border: 1px solid #ccc !important;

  background: #D7DEE6 !important;
  color: #fff !important;
}

.ag-header-cell-text {
  /* color: #344049 !important; */
  color: #344049;
  font-family: Jost;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 250%;
}

.editvaluedata {
  color: var(--text-color) !important;
  text-align: left !important;
  font-size: 12px !important;

}


.ag-cell[col-id='country'] {
  overflow: visible !important;
}

.npi-title {
  color: rgba(0, 144, 248, 1) !important;
}

.ag-popup {
  background-color: white !important;
  /* Custom popup background color */
}


/* Additional specific styling if needed */
.ag-popup .ag-menu {
  background-color: white !important;
  /* Custom menu background color within popup */
}

.ag-tabs-header .ag-menu-header {
  background-color: white !important;
}

.ag-popup .ag-tabs {
  background-color: white;
}

.ag-popup .ag-tab-selected {
  background-color: white;
}

.ag-theme-material .ag-checkbox-input-wrapper.ag-checked::after {
  color: #fffff1 !important;
}

.old-value-text {
  color: var(--error-color);
  text-decoration: line-through;
  margin-right: 5px;
  font-size: 12px;
}

.new-value-text {
  color: var(--secondary-color);
}

.ag-ltr .ag-header-cell-resize {
  opacity: 0;
}


.ag-body-viewport-wrapper.ag-layout-normal {
  overflow-x: scroll;
  overflow-y: scroll;
}


.edited-cell-custom {
  background-color: #FFF3CD !important;
  /* soft amber highlight for changed cells */
}


div.ag-row-hover:not(.ag-row-group) div {
  background-color: #f8dbdb !important;

}

.ag-row {
  border-bottom: 4px solid #f8f8f8 !important;
  border-top: 4px solid #f8f8f8 !important;
}

.ag-header {
  border: none;
  /* Remove header border */
}

/* Remove borders from header cells */
.ag-header-cell {
  border: none;
  /* Remove borders from header cells */
}

.ag-row {
  border: none;
  /* Remove border for rows */
}

/* Remove borders around individual cells */
.ag-cell {
  border: none;
  /* Remove cell borders */
}

/* .ag-header-cell {
  border-right: 1px solid #ccc; 
} */

.ag-header-cell:last-child {
  border-right: none;
  /* Remove the line from the last header cell */
}

.ag-header-cell:last-child::after {
  display: none;
  /* Remove the line from the last header cell */
}

.ag-header-cell-resize {
  height: 10px;
  /* Set a custom height */
  top: 50%;
  /* Vertically center the resize handle */
  margin-top: -5px;
  /* Adjust the position if needed */
}

/* div.ag-row-hover .ag-cell-inline-editing div {
  color: black;
} */


/* Custom styles for the header menu button */
.ag-header-icon.ag-header-cell-menu-button {
  color: white !important;
  fill: white !important;
}

/* .ag-theme-quartz .ag-header-cell-menu-button {
  background-color: white;
  color: black;
}

.ag-theme-quartz .ag-header-cell-menu-button:hover {
  background-color: #f5f5f5;
} */

/* .ag-header-cell-comp-wrapper .ag-icon-menu{
  color: white !important;
}


.ag-header-cell-comp-wrapper .ag-icon-asc{
  color: white !important;
}

.ag-header-cell-comp-wrapper .ag-icon-desc{
  color: white !important;
}

.ag-header-cell-comp-wrapper .ag-icon-filter{
  color: white !important;
} */

.ag-paging-panel {
  font-size: 12px !important;
}

/* Optional: Change the dropdown options background and text color */
.ag-paging-panel .ag-page-size-select option {
  background-color: #e0f7fa;
  /* Same as dropdown background color */
  color: #00796b;
  /* Same as dropdown text color */
}


/* 
   DEFINITIVE VERIFIED AG GRID ICON FIX: Uses the project's own verified character codes.
   Ensures arrows and menu dots appear exactly as they did before the upgrade.
*/
.ag-icon,
.ag-icon::before {
  font-family: "agGridAlpine" !important;
  background: transparent none !important;
  mask: none !important;
  -webkit-mask: none !important;
  display: inline-block !important;
  font-style: normal !important;
  font-weight: normal !important;
  color: inherit !important;
  width: 1em !important;
  height: 1em !important;
  line-height: 1 !important;
}

.ag-icon-menu::before,
.ag-icon-menu-alt::before {
  content: '\\f138' !important;
}

.ag-icon-filter::before {
  content: '\\f115' !important;
}

.ag-icon-first::before    { content: '\\f116' !important; }
.ag-icon-previous::before { content: '\\f126' !important; }
.ag-icon-next::before     { content: '\\f120' !important; }
.ag-icon-last::before     { content: '\\f119' !important; }

.ag-icon-small-down::before { content: '\\f12b' !important; }
.ag-icon-small-right::before, .ag-icon-tree-closed::before { content: '\\f130' !important; }
.ag-icon-tree-open::before { content: '\\f132' !important; }
.ag-icon-small-up::before { content: '\\f12e' !important; }
.ag-icon-small-left::before { content: '\\f12c' !important; }






.ag-floating-filter .ag-floating-filter-input .ag-text-field-input-wrapper .ag-input-field-input {
  border: none !important;
  color: #344049 !important;
  font-weight: 400 !important;
}

/* .ag-icon-menu::before{
  content: '\\f11e'
} */

.cellCenter .ag-cell-wrapper {
  margin-left: '30px !important'
}

.edited-cell {
  border-radius: 10px;
  /* Additional styling as needed */
}

.ag-row-odd {
  background-color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/AgGridCustom.css"],"names":[],"mappings":"AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,4CAA4C;EAC5C,uCAAuC;EACvC,iDAAiD;EACjD,sDAAsD;EACtD,wCAAwC;;;EAGxC,kDAAkD;;AAEpD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;;AAGA;EACE,6CAA6C;EAC7C,mCAAmC;EACnC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,sDAAsD;EACtD,iCAAiC;;EAEjC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,0BAA0B;;AAE5B;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;;AAGA,0CAA0C;AAC1C;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;;;AAGA;EACE,oCAAoC;;AAEtC;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,QAAQ;EACR,wCAAwC;EACxC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;GAEG;;;AAGH,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;;;;;GAOG;;AAEH;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA,oEAAoE;AACpE;EACE,yBAAyB;EACzB,sCAAsC;EACtC,cAAc;EACd,gCAAgC;AAClC;;;AAGA;;;CAGC;AACD;;EAEE,sCAAsC;EACtC,uCAAuC;EACvC,qBAAqB;EACrB,6BAA6B;EAC7B,gCAAgC;EAChC,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,4BAA4B,2BAA2B,EAAE;AACzD,4BAA4B,2BAA2B,EAAE;AACzD,4BAA4B,2BAA2B,EAAE;AACzD,4BAA4B,2BAA2B,EAAE;;AAEzD,8BAA8B,2BAA2B,EAAE;AAC3D,6DAA6D,2BAA2B,EAAE;AAC1F,6BAA6B,2BAA2B,EAAE;AAC1D,4BAA4B,2BAA2B,EAAE;AACzD,8BAA8B,2BAA2B,EAAE;;;;;;;AAO3D;EACE,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;GAEG;;AAEH;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["@import './variables.css';\n\n.ag-theme-quartz {\n  --ag-background-color: 'transparent';\n  /* --ag-background-color: white; */\n  --ag-header-column-separator-display: 'none';\n  --ag-checkbox-background-color: #E0E0E0;\n  --ag-checkbox-checked-color: var(--primary-color);\n  --ag-checkbox-unchecked-color: var(--background-color);\n  --ag-checkbox-indeterminate-color: white;\n\n\n  --ag-header-column-separator-width: 0px !important;\n\n}\n\n.ag-theme-quartz .ag-popup {\n  background-color: white !important;\n}\n\n.ag-root-wrapper {\n  border: none;\n  border-radius: 8px 8px 0px 0px;\n}\n\n\n.ag-ltr .ag-cell {\n  /* border-right: 1px solid #ccc !important; */\n  color: var(--text-color) !important;\n  text-align: left !important;\n  font-size: 12px !important;\n}\n\n.ag-header-cell {\n  /* background-color: var(--primary-color) !important;*/\n  border: 1px solid #ccc !important;\n\n  background: #D7DEE6 !important;\n  color: #fff !important;\n}\n\n.ag-header-cell-text {\n  /* color: #344049 !important; */\n  color: #344049;\n  font-family: Jost;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 250%;\n}\n\n.editvaluedata {\n  color: var(--text-color) !important;\n  text-align: left !important;\n  font-size: 12px !important;\n\n}\n\n\n.ag-cell[col-id='country'] {\n  overflow: visible !important;\n}\n\n.npi-title {\n  color: rgba(0, 144, 248, 1) !important;\n}\n\n.ag-popup {\n  background-color: white !important;\n  /* Custom popup background color */\n}\n\n\n/* Additional specific styling if needed */\n.ag-popup .ag-menu {\n  background-color: white !important;\n  /* Custom menu background color within popup */\n}\n\n.ag-tabs-header .ag-menu-header {\n  background-color: white !important;\n}\n\n.ag-popup .ag-tabs {\n  background-color: white;\n}\n\n.ag-popup .ag-tab-selected {\n  background-color: white;\n}\n\n.ag-theme-material .ag-checkbox-input-wrapper.ag-checked::after {\n  color: #fffff1 !important;\n}\n\n.old-value-text {\n  color: var(--error-color);\n  text-decoration: line-through;\n  margin-right: 5px;\n  font-size: 12px;\n}\n\n.new-value-text {\n  color: var(--secondary-color);\n}\n\n.ag-ltr .ag-header-cell-resize {\n  opacity: 0;\n}\n\n\n.ag-body-viewport-wrapper.ag-layout-normal {\n  overflow-x: scroll;\n  overflow-y: scroll;\n}\n\n\n.edited-cell-custom {\n  background-color: #FFF3CD !important;\n  /* soft amber highlight for changed cells */\n}\n\n\ndiv.ag-row-hover:not(.ag-row-group) div {\n  background-color: #f8dbdb !important;\n\n}\n\n.ag-row {\n  border-bottom: 4px solid #f8f8f8 !important;\n  border-top: 4px solid #f8f8f8 !important;\n}\n\n.ag-header {\n  border: none;\n  /* Remove header border */\n}\n\n/* Remove borders from header cells */\n.ag-header-cell {\n  border: none;\n  /* Remove borders from header cells */\n}\n\n.ag-row {\n  border: none;\n  /* Remove border for rows */\n}\n\n/* Remove borders around individual cells */\n.ag-cell {\n  border: none;\n  /* Remove cell borders */\n}\n\n/* .ag-header-cell {\n  border-right: 1px solid #ccc; \n} */\n\n.ag-header-cell:last-child {\n  border-right: none;\n  /* Remove the line from the last header cell */\n}\n\n.ag-header-cell:last-child::after {\n  display: none;\n  /* Remove the line from the last header cell */\n}\n\n.ag-header-cell-resize {\n  height: 10px;\n  /* Set a custom height */\n  top: 50%;\n  /* Vertically center the resize handle */\n  margin-top: -5px;\n  /* Adjust the position if needed */\n}\n\n/* div.ag-row-hover .ag-cell-inline-editing div {\n  color: black;\n} */\n\n\n/* Custom styles for the header menu button */\n.ag-header-icon.ag-header-cell-menu-button {\n  color: white !important;\n  fill: white !important;\n}\n\n/* .ag-theme-quartz .ag-header-cell-menu-button {\n  background-color: white;\n  color: black;\n}\n\n.ag-theme-quartz .ag-header-cell-menu-button:hover {\n  background-color: #f5f5f5;\n} */\n\n/* .ag-header-cell-comp-wrapper .ag-icon-menu{\n  color: white !important;\n}\n\n\n.ag-header-cell-comp-wrapper .ag-icon-asc{\n  color: white !important;\n}\n\n.ag-header-cell-comp-wrapper .ag-icon-desc{\n  color: white !important;\n}\n\n.ag-header-cell-comp-wrapper .ag-icon-filter{\n  color: white !important;\n} */\n\n.ag-paging-panel {\n  font-size: 12px !important;\n}\n\n/* Optional: Change the dropdown options background and text color */\n.ag-paging-panel .ag-page-size-select option {\n  background-color: #e0f7fa;\n  /* Same as dropdown background color */\n  color: #00796b;\n  /* Same as dropdown text color */\n}\n\n\n/* \n   DEFINITIVE VERIFIED AG GRID ICON FIX: Uses the project's own verified character codes.\n   Ensures arrows and menu dots appear exactly as they did before the upgrade.\n*/\n.ag-icon,\n.ag-icon::before {\n  font-family: \"agGridAlpine\" !important;\n  background: transparent none !important;\n  mask: none !important;\n  -webkit-mask: none !important;\n  display: inline-block !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  color: inherit !important;\n  width: 1em !important;\n  height: 1em !important;\n  line-height: 1 !important;\n}\n\n.ag-icon-menu::before,\n.ag-icon-menu-alt::before {\n  content: '\\f138' !important;\n}\n\n.ag-icon-filter::before {\n  content: '\\f115' !important;\n}\n\n.ag-icon-first::before    { content: '\\f116' !important; }\n.ag-icon-previous::before { content: '\\f126' !important; }\n.ag-icon-next::before     { content: '\\f120' !important; }\n.ag-icon-last::before     { content: '\\f119' !important; }\n\n.ag-icon-small-down::before { content: '\\f12b' !important; }\n.ag-icon-small-right::before, .ag-icon-tree-closed::before { content: '\\f130' !important; }\n.ag-icon-tree-open::before { content: '\\f132' !important; }\n.ag-icon-small-up::before { content: '\\f12e' !important; }\n.ag-icon-small-left::before { content: '\\f12c' !important; }\n\n\n\n\n\n\n.ag-floating-filter .ag-floating-filter-input .ag-text-field-input-wrapper .ag-input-field-input {\n  border: none !important;\n  color: #344049 !important;\n  font-weight: 400 !important;\n}\n\n/* .ag-icon-menu::before{\n  content: '\\f11e'\n} */\n\n.cellCenter .ag-cell-wrapper {\n  margin-left: '30px !important'\n}\n\n.edited-cell {\n  border-radius: 10px;\n  /* Additional styling as needed */\n}\n\n.ag-row-odd {\n  background-color: #fff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
